import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { acceptLanguage } from '~/i18n.config';
var useI18nLocale = function useI18nLocale() {
  // enforce type for i18n to avoid updating the global definition (and huge refactoring) in nuxt.d.ts (which is probably wrong)
  var _ref = useNuxt2App(),
    _ref$i18n = _ref.i18n,
    i18nLocale = _ref$i18n.locale,
    defaultLocale = _ref$i18n.defaultLocale,
    locales = _ref$i18n.locales;
  var isDefaultLocale = function isDefaultLocale() {
    var currentLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : i18nLocale;
    return currentLocale === defaultLocale;
  };
  var isLocaleAccepted = function isLocaleAccepted(locale) {
    return acceptLanguage.includes(locale);
  };
  var getLocaleByCode = function getLocaleByCode(desiredLocaleCode) {
    return locales.find(function (locale) {
      return locale.code === desiredLocaleCode;
    });
  };
  var getCurrentLocale = function getCurrentLocale() {
    return getLocaleByCode(i18nLocale);
  };
  return {
    isDefaultLocale: isDefaultLocale,
    getLocaleByCode: getLocaleByCode,
    getCurrentLocale: getCurrentLocale,
    isLocaleAccepted: isLocaleAccepted,
    acceptLanguage: acceptLanguage
  };
};
export default useI18nLocale;